<template>
  <custom-plane
    title="排水管网"
    :iconImg="require('@/assets/environment/air-env.png')"
  >
    <div class="network-content">
      <div class="top-content">
        <div class="left-name">
          管网
        </div>
        <div class="right-content">
          <div class="air-item" v-for="item in networkArray">
            <div class="name">{{ item.name }}</div>
            <div class="detail">
              <div class="detail-num">
                {{ item.num }}
              </div>
              <div class="detail-unit">
                {{ item.unit }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-content">
        <div class="left-name">化粪池</div>
        <div class="right-content">
          <div class="air-item" v-for="item in septicArray">
            <div class="name">{{ item.name }}</div>
            <div class="detail">
              <div
                class="detail-num"
                :class="item.alarm == '0' ? '' : 'error-color'"
              >
                {{ item.num }}
              </div>
              <div class="detail-unit">
                {{ item.unit }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-content top-content1">
        <div class="left-name">集水井</div>
        <div class="right-content">
          <div class="air-item" v-for="item in sumpArray">
            <div class="name">{{ item.name }}</div>
            <div class="detail">
              <div
                class="detail-num"
                :class="item.alarm == '0' ? '' : 'error-color'"
              >
                {{ item.num }}
              </div>
              <div class="detail-unit">
                {{ item.unit }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {
  props: {
    networkArray: Array,
    septicArray: Array,
    sumpArray: Array,
  },
};
</script>

<style lang="scss" scoped>
.network-content {
  padding: 20px;
  .top-content {
    display: flex;
    margin-bottom: 20px;
    .left-name {
      width: 42px;
      height: 57px;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #e5e5e5;
      white-space: nowrap;
      margin-right: 18px;
    }
    .right-content {
      width: 316px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .air-item {
        width: 98px;
        height: 57px;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 10px;
        .name {
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
          color: #e5e5e5;
        }
        .detail {
          color: #2d82ff;
          font-weight: 500;
          font-family: "dina";
          display: flex;
          align-items: baseline;
          .feng-num {
            font-family: "source" !important;
            font-size: 22px !important;
          }
          .detail-num {
            font-size: 28px;
            line-height: 32px;
            font-family: "dina";
          }
          .detail-unit {
            font-size: 14px;
            font-family: "dina";
          }
        }
      }
    }
  }
  .top-content1 {
    margin-bottom: 0px !important;
  }
}
</style>
